/**
 * @generated SignedSource<<083b240d792a8b3bcef2fa3b7a4f272a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

import BillingGroupPractitionersTableRefetch_graphql from './BillingGroupPractitionersTableRefetch.graphql';

var node = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "billingGroupId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "firstName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "lastName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "locationName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "npi"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tin"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": BillingGroupPractitionersTableRefetch_graphql
    }
  },
  "name": "BillingGroupPractitionersTableFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "billingGroupId",
              "variableName": "billingGroupId"
            },
            {
              "kind": "Variable",
              "name": "firstName",
              "variableName": "firstName"
            },
            {
              "kind": "Variable",
              "name": "lastName",
              "variableName": "lastName"
            },
            {
              "kind": "Variable",
              "name": "locationName",
              "variableName": "locationName"
            },
            {
              "kind": "Variable",
              "name": "npi",
              "variableName": "npi"
            },
            {
              "kind": "Variable",
              "name": "tIN",
              "variableName": "tin"
            }
          ],
          "kind": "ObjectValue",
          "name": "input"
        }
      ],
      "concreteType": "Practitioner",
      "kind": "LinkedField",
      "name": "filteredPractitioners",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PractitionerIdentifier",
          "kind": "LinkedField",
          "name": "identifiers",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "IdentifierType",
              "kind": "LinkedField",
              "name": "identifierType",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PractitionerVersion",
          "kind": "LinkedField",
          "name": "applicableVersion",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

node.hash = "f9f5672df143d277810e7a8f7df43d70";

export default node;
